let BASE_URL =
  process.env.REACT_APP_ENV === "txt"
    ? "https://services.pro.tsthellobank.be"
    : process.env.REACT_APP_ENV === "qa"
    ? "https://services.pro.qahellobank.be"
    : process.env.REACT_APP_ENV === "prod"
    ? "https://services.pro.hellobank.be"
    : process.env.REACT_APP_ENV === "dev"
    ? "http://localhost:7001"
    : "https://services.pro.tsthellobank.be";

export { BASE_URL };
//
